import { Instagram, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

const INSTA = "https://instagram.com/dimaginationaljanatadal";

const TILES = [
  { t: "Roads that actually last", c: "#FF9933" },
  { t: "Every child, a school seat", c: "#38BDF8" },
  { t: "Compassion for strays", c: "#A78BFA" },
  { t: "Health at the doorstep", c: "#F43F5E" },
  { t: "Power without cuts", c: "#EAB308" },
  { t: "Clean streets, clean air", c: "#138808" },
];

export function InstagramSection() {
  return (
    <section id="follow" className="relative max-w-6xl mx-auto px-4 py-20">
      <div className="rounded-3xl border border-border bg-card overflow-hidden">
        <div className="grid md:grid-cols-2">
          <div className="p-8 sm:p-12">
            <div className="inline-flex items-center gap-2 rounded-full border border-saffron/40 bg-saffron/10 px-3 py-1 text-xs font-mono text-saffron">
              <Instagram size={13} /> @dimaginationaljanatadal
            </div>
            <h2 className="mt-5 font-display font-extrabold text-3xl sm:text-4xl tracking-tight">
              Follow the movement
            </h2>
            <p className="mt-4 text-muted-foreground max-w-md">
              Real issues, real neighbourhoods, real progress. See the wins, the campaigns
              and the citizens changing India — one square at a time.
            </p>
            <a
              data-testid="instagram-follow-button"
              href={INSTA}
              target="_blank"
              rel="noreferrer"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-saffron px-6 py-3 font-semibold text-primary-foreground hover:bg-saffron/90 transition-colors"
            >
              <Instagram size={18} /> Follow on Instagram
              <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="relative chess-grid p-8 sm:p-12 grid grid-cols-2 sm:grid-cols-3 gap-3 bg-background/40">
            {TILES.map((tile, i) => (
              <motion.a
                key={tile.t}
                href={INSTA}
                target="_blank"
                rel="noreferrer"
                data-testid="instagram-feed-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className="aspect-square rounded-xl p-3 flex items-end text-white text-xs font-semibold leading-tight"
                style={{ background: `linear-gradient(160deg, ${tile.c}, ${tile.c}99)` }}
              >
                {tile.t}
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
